import useTranslation from 'next-translate/useTranslation';
import { twMerge } from 'tailwind-merge';
import ButtonIelts, { ButtonColorScheme } from '@/components/common/ButtonIelts';
import explainIcon from '@/components/ielts/listening/assets/images/explain.svg';
import { DinRoundProFont } from '@/lib/utils';

function IeltsListeningExplainButton({ onClick }: { onClick?: () => void }) {
  const { t } = useTranslation('ielts');

  return (
    <ButtonIelts
      className="!w-[108px] !h-[30px] min-h-[36px] min-w-0 hover:!bg-[#8D71DE]"
      wrapClassName="hover:!bg-[#8D71DE]"
      onClick={onClick}
      title={t('listening_reading.explain')}
      customTextStyle={twMerge('font-extrabold text-sm', DinRoundProFont.className)}
      Icon={explainIcon}
      classNameIcon="w-6 h-6"
      typeButton={ButtonColorScheme.Gray}
      style={{
        width: '108px',
        height: '36px',
      }}
    />
  );
}

export default IeltsListeningExplainButton;
